/* tslint:disable */
/* eslint-disable */
/**
 * Ship to ship api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Schema for the parameters field inside a configuration.
 * @export
 * @interface ConfigurationParametersSchema
 */
export interface ConfigurationParametersSchema {
    /**
     * Distance threshold for STS in meters
     * @type {number}
     * @memberof ConfigurationParametersSchema
     */
    distanceForStsMeters: number;
    /**
     * Time window for transfer in minutes
     * @type {number}
     * @memberof ConfigurationParametersSchema
     */
    transferTimeWindowMinutes: number;
    /**
     * UUID of the filter applied to this configuration
     * @type {string}
     * @memberof ConfigurationParametersSchema
     */
    filterUuid?: string | null;
}

/**
 * Check if a given object implements the ConfigurationParametersSchema interface.
 */
export function instanceOfConfigurationParametersSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "distanceForStsMeters" in value;
    isInstance = isInstance && "transferTimeWindowMinutes" in value;

    return isInstance;
}

export function ConfigurationParametersSchemaFromJSON(json: any): ConfigurationParametersSchema {
    return ConfigurationParametersSchemaFromJSONTyped(json, false);
}

export function ConfigurationParametersSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationParametersSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'distanceForStsMeters': json['distance_for_sts_meters'],
        'transferTimeWindowMinutes': json['transfer_time_window_minutes'],
        'filterUuid': !exists(json, 'filter_uuid') ? undefined : json['filter_uuid'],
    };
}

export function ConfigurationParametersSchemaToJSON(value?: ConfigurationParametersSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'distance_for_sts_meters': value.distanceForStsMeters,
        'transfer_time_window_minutes': value.transferTimeWindowMinutes,
        'filter_uuid': value.filterUuid,
    };
}

